import Vue from 'vue';
import App from './App.vue';
import router from './router';
import axios from 'axios';
import api from './api';
import VConsole from 'vconsole';
import '@/assets/style/base.css';
import '@/assets/style/brand-theme.css';
import brand, { applyBrandTheme } from './brand';
import i18n from './language/index';
import {
  Row,
  Col,
  Collapse,
  CollapseItem,
  Divider,
  NavBar,
  CellGroup,
  Cell
} from 'vant';

function hasVConsoleQuery() {
  if (/[?&]vconsole=1(?:&|$)/.test(window.location.search)) {
    return true;
  }
  // hash 路由：http://xxx/#/topup?vconsole=1
  const hash = window.location.hash || '';
  const qIndex = hash.indexOf('?');
  if (qIndex === -1) {
    return false;
  }
  return /(?:^|[?&])vconsole=1(?:&|$)/.test(hash.slice(qIndex + 1));
}

// 开发 / 测试环境默认开启；正式环境 URL 加 ?vconsole=1 也可开启
if (
  process.env.NODE_ENV !== 'production' ||
  process.env.VUE_APP_ENABLE_VCONSOLE === 'true' ||
  hasVConsoleQuery()
) {
  // eslint-disable-next-line no-new
  new VConsole();
}

applyBrandTheme();

Vue.use(Divider);
Vue.use(Row);
Vue.use(Col);
Vue.use(Collapse);
Vue.use(CollapseItem);
Vue.use(CellGroup);
Vue.use(Cell);
Vue.use(NavBar);
function setupFlexible() {
  const docEl = document.documentElement
  const maxWidth = 750

  // 750 设计稿 + postcss-pxtorem(rootValue:50) → 1rem = 视口宽度 / 15
  function setRemUnit() {
    const width = Math.min(docEl.clientWidth || window.innerWidth, maxWidth)
    docEl.style.fontSize = width / 15 + 'px'
  }

  setRemUnit()
  window.addEventListener('resize', setRemUnit)
  // 老款 Android / MIUI 旋转后 clientWidth 更新延迟，需延后重算
  window.addEventListener('orientationchange', () => {
    setTimeout(setRemUnit, 300)
  })
  window.addEventListener('pageshow', (e) => {
    if (e.persisted) setRemUnit()
  })
}
setupFlexible()
function px2rem(px) {
  if (/%/ig.test(px)) { // 有百分号%，特殊处理，表述pc是一个有百分号的数，比如：90%
    return px
  } else {
    return (parseFloat(px) / 75) + 'rem'
  }
}
Vue.prototype.$px2rem = px2rem
Vue.prototype.$imgBaseUrl = process.env.VUE_APP_IMG_BASE_URL
Vue.prototype.$brand = brand;
Vue.prototype.$api = api;
Vue.prototype.$axios = axios;
Vue.prototype.$env = {
  baseApi: process.env.VUE_APP_BASE_API,
  webUrl: process.env.VUE_APP_WEB_URL
};

new Vue({
  router,
  i18n,
  render: h => h(App),
}).$mount('#app');
